import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, inject, ChangeDetectorRef } from '@angular/core';
import {
    FuseNavigationService,
    FuseVerticalNavigationComponent,
} from '@fuse/components/navigation';
import { Router, RouterLinkActive, RouterModule } from '@angular/router';
import {
    BehaviorSubject,
    delay,
    filter,
    merge,
    Observable,
    ReplaySubject,
    Subject,
    Subscription,
    takeUntil,
    switchMap,
    map,
    catchError,
    of,
    throwError,
    EMPTY,
} from 'rxjs';
import { LinkService } from 'app/_helpers/link-service.service';
import { NavigationExtras } from '@angular/router';
import { LogoParrainComponent } from '../logo-parrain/logo-parrain.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { ParrainStore } from 'app/modules/admin/stores/parrain.store';
import { ParrainAnnonceService } from 'app/_services/parrain-annonce.service';
import { ParrainNavigationService } from 'app/_services/parrain-navigation.service';
import {StorageService} from "../../modules/auth/services/storage.service";
import {MatDialog} from "@angular/material/dialog";
import {CONSTANTS} from "../../_helpers/constants";
import {ProfileSelectionDialogComponent} from "./profile-selection-dialog/profile-selection-dialog.component";
@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
        MatDividerModule,
        RouterModule,
        RouterLinkActive,
        LogoParrainComponent,
    ],
})
export class FooterComponent {
    private _linkService = inject(LinkService);
    private _fuseNavigationService = inject(FuseNavigationService);
    private _router = inject(Router);
    private _changeDetectorRef = inject(ChangeDetectorRef);
    private _parrainAnnonceService = inject(ParrainAnnonceService);
    readonly parrainStore = inject(ParrainStore);
    private _parrainNav = inject(ParrainNavigationService);
    private _storageService = inject(StorageService);
    private _dialog = inject(MatDialog);
    isPlayer: boolean = false;
    isParent: boolean = false;
    isPlayerOnly: boolean = false;
    isParentOnly: boolean = false;
    isParentAndPlayer: boolean = false;
    userId: string = '';
    children: any[] = [];

    ngOnInit(): void {
        this.checkUserRoles();
    }

    /**
     * Vérifie les rôles de l'utilisateur et met à jour les propriétés
     */
    private checkUserRoles(): void {
        const userInfo = this._storageService.getUserInfo();
        const allRoles = this._storageService.getRoles();

        if (userInfo?.id) {
            this.userId = userInfo.id;
        }

        if (userInfo?.roles && allRoles) {
            // Vérifier si l'utilisateur est un joueur
            this.isPlayer = userInfo.roles.some((userRole) => {
                const roleDetails = allRoles.find((r) => r.name === userRole);
                return roleDetails?.level === CONSTANTS.LEVEL_PLAYER;
            });

            // Vérifier si l'utilisateur est un parent
            this.isParent = userInfo.roles.some((userRole) => {
                const roleDetails = allRoles.find((r) => r.name === userRole);
                return roleDetails?.level === CONSTANTS.LEVEL_PARENT;
            });

            // Déterminer les combinaisons de rôles
            this.isPlayerOnly = this.isPlayer && !this.isParent;
            this.isParentOnly = this.isParent && !this.isPlayer;
            this.isParentAndPlayer = this.isPlayer && this.isParent;
        }
    }

    /**
     * Ouvre le dialog pour afficher les profils des enfants (parent uniquement)
     */
    openChildrenProfilesDialog(): void {
        const dialogRef = this._dialog.open(ProfileSelectionDialogComponent, {
            width: '400px',
            data: {
                userId: this.userId,
                parentId: this.userId,
                showMyProfile: false // Ne pas afficher l'option "Mon profil"
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result?.selectedChildId) {
                this._router.navigate(['/player-profile', result.selectedChildId]);
            }
        });
    }

    /**
     * Ouvre le dialog pour sélectionner entre le profil du parent/joueur et les enfants
     */
    openProfileSelectionDialog(): void {
        const dialogRef = this._dialog.open(ProfileSelectionDialogComponent, {
            width: '400px',
            data: {
                userId: this.userId,
                parentId: this.userId,
                showMyProfile: true // Afficher l'option "Mon profil"
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result?.action === 'myProfile') {
                this._router.navigate(['/player-profile', this.userId]);
            } else if (result?.action === 'childProfile' && result?.selectedChildId) {
                this._router.navigate(['/player-profile', result.selectedChildId]);
            }
        });
    }
    onClick(url: string) {
        this.sendMessage({ url: url });
        this._linkService.openLinkInNativeView(url);
    }

    sendMessage(data: { url: string }) {
        const message = JSON.stringify(data);
        window.postMessage(message, '*');
    }

    toggleNavigation(name: string): void {
        const navigation =
            this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(
                name
            );
        if (navigation) {
            navigation.toggle();
        }
    }
    onShowParrainSpace(sponsorId?: string | null): void {
        if (!sponsorId) return;
        this._parrainNav.onShowParrainSpace(sponsorId);
        this._changeDetectorRef.markForCheck();
    }
    // private navigateAndClose(commands: any[], extras?: NavigationExtras) {
    //     this._router.navigate(commands, extras).then(() => {
    //         this._changeDetectorRef.markForCheck();
    //     });
    // }

    // onShowParrainSpace(sponsorId: string): void {
    //     this._parrainAnnonceService
    //         .getParrainIdBySponsorId(sponsorId)
    //         .pipe(
    //             // 404 -> on va direct sur la page détail (fallback)
    //             catchError((err) => {
    //                 if (err?.status === 404) {
    //                     this.navigateAndClose([
    //                         '/partenaire-detail',
    //                         sponsorId,
    //                     ]);
    //                     return EMPTY;
    //                 }
    //                 return throwError(() => err);
    //             }),
    //             switchMap((parrainId) => {
    //                 if (!parrainId) {
    //                     // Aucun lien trouvé, même traitement que 404
    //                     this.navigateAndClose([
    //                         '/partenaire-detail',
    //                         sponsorId,
    //                     ]);
    //                     return EMPTY;
    //                 }
    //                 // Sinon on cherche l’annonce approuvée
    //                 return this._parrainAnnonceService
    //                     .getAnnonceApprouveeByParrainId(parrainId)
    //                     .pipe(
    //                         map((annonce) => ({ parrainId, annonce })),
    //                         // si 404 sur l’annonce -> on va au détail parrain
    //                         catchError(() => of({ parrainId, annonce: null }))
    //                     );
    //             })
    //         )
    //         .subscribe(({ parrainId, annonce }) => {
    //             if (annonce) {
    //                 this.navigateAndClose(['/pub-parrain', annonce.id], {
    //                     queryParams: { sponsorId },
    //                 });
    //             } else {
    //                 this.navigateAndClose(['/partenaire-detail', parrainId]);
    //             }
    //         });
    // }
}
